// @ts-ignore
// import core jquery or replace with custom file
require('../../../../resources/js/jquery');
import { render } from '../../../../resources/js/render';
render({});
